import { notificationService } from '../../services';
import { SubmitPushNotificationRequestDTO } from '../../../../../shared/components/push/dto/PushNotificationRequest.dto';

const pushNotification = async (
  request: SubmitPushNotificationRequestDTO,
): Promise<void> => {
  const result = await notificationService.pushNotification(request);
  console.log(result);

  if (result.isLeft()) {
    const error = result.value;
    throw new Error(error.message);
  } else {
    return result.value.getValue();
  }
};

export default pushNotification;
